import store from "@/store";

import { _updateData } from "@/api/esdata";
import { checkDocumentExist } from "@/api/documentexist";

export const settingZoneExplain = (parentVue) => {
    return {
        description:
            "<p>Here you can create you waf rules, rules are combinations of <strong>Conditions</strong> and <strong>Action</strong>. You can have some quick snippet from below example rules </p>",
    };
};

export const groupName = (parentVue) => {
    return {};
};
export const description = (parentVue) => {
    return {
        sectionKey: "essential",
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;
            return h(
                "Input",
                {
                    props: {
                        value: params.row.description,
                        disabled: vm.isEditBtnDisabled,
                    },
                    on: {
                        "on-blur": (event) => {
                            if (params.row.description !== event.target.value) {
                                params.row.description = event.target.value;
                                _updateData("rcm-wafrules", "partialUpdate", {
                                    // docId: `${params.row.groupName}-${params.row.ruleName}`,
                                    docId: params.row._id,
                                    groupName: params.row.groupName,
                                    updateData: {
                                        description: params.row.description,
                                    },
                                    esIndex: "rcm-wafrules",
                                })
                                    .then((result) => {
                                        vm.$Notice.success({
                                            title: vm.$i18n.t("global.success"),
                                            desc: `${result.data.message}`,
                                        });
                                    })
                                    .catch(function (error) {
                                        vm.$Notice.warning({
                                            title: vm.$i18n.t("global.error"),
                                            desc: `${error}`,
                                        });
                                        vm.getTableData();
                                    });
                            }
                        },
                    },
                },
                ""
            );
        },
    };
};
export const ruleName = (parentVue) => {
    return {
        validate: [
            {
                required: true,
                message: "Missing Rule Name",
                trigger: "blur",
            },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!/^[a-z0-9\_]*$/.test(value))
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 _`));
                    if (value.length > 35)
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateExceedLengthPrefix")}: 35`));
                    checkDocumentExist({
                        topic: "wafRuleName",
                        fieldVal: value,
                        groupName: vm.formData.groupName,
                    }).then((result) => {
                        if (!result.data.success) {
                            return callback(new Error("Duplicate ruleName"));
                        }
                        callback();
                    });
                },
                trigger: "blur",
            },
        ],
    };
};



// WEBPACK FOOTER //
// ./src/view/WafRules/fields.js